/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View } from '@components/atoms'

export const TabConfigView = () => {
	return <View css={style} className="configOuter"></View>
}

const style = css({
	position: 'absolute',
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	width: '4rem',
	right: 0,
})
